import apiClient from '../config/api';

const adminService = {
  // Get all tenants
  getAllTenants: async () => {
    const response = await apiClient.get('/admin/tenants');
    return response.data;
  },

  // Update tenant subscription
  updateTenantSubscription: async (tenantId, subscriptionData) => {
    const response = await apiClient.post(`/admin/update/tenants/${tenantId}/subscription`, subscriptionData);
    return response.data;
  },

  // Get all subscription plans
  getAllSubscriptionPlans: async () => {
    const response = await apiClient.get('/admin/subscription-plans');
    return response.data;
  },

  // Get tenant usage
  getTenantUsage: async (tenantId) => {
    const response = await apiClient.get(`/admin/tenants/${tenantId}/usage`);
    return response.data;
  },

  // Email Templates
  getEmailTemplates: async () => {
    const response = await apiClient.get('/admin/notification-templates');
    return response.data;
  },

  getEmailTemplate: async (id) => {
    const response = await apiClient.get(`/admin/notification-templates/${id}`);
    return response.data;
  },

  createEmailTemplate: async (templateData) => {
    const response = await apiClient.post('/admin/notification-templates', templateData);
    return response.data;
  },

  updateEmailTemplate: async (id, templateData) => {
    const response = await apiClient.post(`/admin/update/notification-templates/${id}`, templateData);
    return response.data;
  },

  deleteEmailTemplate: async (id) => {
    const response = await apiClient.post(`/admin/delete/notification-templates/${id}`);
    return response.data;
  },

  getTemplateVariables: async (code) => {
    const response = await apiClient.get(`/admin/notification-templates/${code}/variables`);
    return response.data;
  },

  // Message Queue
  getMessageQueue: async (params = {}) => {
    const response = await apiClient.get('/admin/message-queue', { params });
    return response.data;
  },

  getMessage: async (id) => {
    const response = await apiClient.get(`/admin/message-queue/${id}`);
    return response.data;
  },

  retryMessage: async (id) => {
    const response = await apiClient.post(`/admin/message-queue/${id}/retry`);
    return response.data;
  },

  deleteMessage: async (id) => {
    const response = await apiClient.post(`/admin/delete/message-queue/${id}`);
    return response.data;
  },

  getTenantWorkspaceOverview: async (tenantId) => {
    const response = await apiClient.get(
      `/admin/tenants/${tenantId}/workspace-overview`,
    );
    return response.data;
  },

  updateTenantWorkspaceOverview: async (tenantId, payload) => {
    const response = await apiClient.post(
      `/admin/update/tenants/${tenantId}/workspace-overview`,
      payload,
    );
    return response.data;
  },

  getNavApps: async () => {
    const response = await apiClient.get("/admin/nav-apps");
    return response.data;
  },

  getNavApp: async (navAppId) => {
    const response = await apiClient.get(`/admin/nav-apps/${navAppId}`);
    return response.data;
  },

  createNavApp: async (payload) => {
    const response = await apiClient.post("/admin/nav-apps", payload);
    return response.data;
  },

  updateNavApp: async (navAppId, payload) => {
    const response = await apiClient.post(`/admin/update/nav-apps/${navAppId}`, payload);
    return response.data;
  },

  deactivateNavApp: async (navAppId) => {
    const response = await apiClient.post(`/admin/delete/nav-apps/${navAppId}`);
    return response.data;
  },

  getTenantNavApps: async (tenantId) => {
    const response = await apiClient.get(`/admin/tenants/${tenantId}/nav-apps`);
    return response.data;
  },

  updateTenantNavApps: async (tenantId, payload) => {
    const response = await apiClient.post(
      `/admin/update/tenants/${tenantId}/nav-apps`,
      payload,
    );
    return response.data;
  },

  uploadScreenshot: async (navAppId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post(`/admin/nav-apps/${navAppId}/screenshots`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};

export default adminService;

